import { WidgetInternalId } from './Widget.types';

export interface DeviceChildConfig {
  readonly key: string;
  readonly widgetId: WidgetInternalId;
  readonly idPrefix: string;
}

export interface DeviceWidgetIds {
  readonly list: WidgetInternalId;
  readonly detail: WidgetInternalId;
  readonly children: readonly DeviceChildConfig[];
}

export interface DeviceTypeConfig {
  readonly widgetIds: DeviceWidgetIds;
  readonly stylePrefix: string;
  readonly errorMessageId: string;
}

export enum DeviceType {
  BMS = 'bms',
  PCS = 'pcs',
  PCS_PV = 'pcsPV',
  MET = 'MET',
}

export interface DeviceWidgetContextValue {
  readonly deviceType: DeviceType;
  readonly config: DeviceTypeConfig;
  readonly isUnitScope: boolean;
}
